<template>
  <div>
    <div
      style="font-size: 0.6rem;"
      class="v-event-draggable pa-1"
      :class="{'greenTopBorder' : (event.status == 'done' ? true : false), 'redTopBorder' : (event.status == 'canceled' ? true : false)}"
    >
      <v-tooltip
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            v-if="event.attendanceStatus > 0"
            v-bind="attrs"
            v-on="on"
            class="attendanceStatus"
          />
        </template>
        <span>{{ $t('attendanceDone') }}</span>
      </v-tooltip>
      <div>{{ (event.student ? event.student.name + '- ': '') }} {{ event.name }} </div>
      <!--      <div>{{$t('from')}} {{eventParsed.start.time}} {{$t('until')}} {{eventParsed.end.time}} {{(event.teacher ? ' - ' + event.teacher.name : '')}}</div>-->
      <div>{{ (event.teacher ? event.teacher.name : '') }}</div>
      <div>{{ $t('class') }} {{ (event.place ? event.place.name : '') }}</div>
    </div>
    <div
      class="v-event-drag-bottom"
      @mousedown.stop="$emit('extendBottom',event)"
    />
  </div>
</template>

<script>
  import General from '../../../../../Mixins/general'
  export default {
    name: 'AcademySession',
    components: {
    },
    mixins: [General],
    props: ['timed', 'event', 'eventSummary', 'eventParsed'],
    data: () => ({
      tag: null,
      render: false,
      isLoading: false,
      status: 'active',
      address: null,
      name: null,
      valid: null,
      message: null,
      id: null,
      loading: false,
    }),
    watch: {
    },
    beforeMount () {
    },
    mounted () {
    },
    methods: {
      allowedStep: m => m % 5 === 0,
      create () {
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'academyPlaces', app.$data)
          .then(res => {
            app.goTo('academyPlaceList')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.isLoading = false))
      },
      show () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'academyPlaces/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            app.$nextTick(() => {
              app.id = res.id
              app.name = res.name
              app.tag = res.tags
              app.address = res.address
              app.render = true
            })
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'academyPlaces/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            app.$emit('close', app.$route)
            app.goTo('academyPlaceList')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
    },
  }
</script>

<style scoped>
.attendanceStatus {
  background-color:#02a15a;
  left:0;
  padding:2px;
  margin-left: 3px;
  position: absolute;
  border-radius: 50%;
  border: 1px solid #ffffff
}
.greenTopBorder {
  border-top: 2px #5fffa6 solid
}
.redTopBorder {
  border-top: 2px #ff0047 solid
}
.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;
}
.v-event-drag-bottom::after {
  display: none;
  position: absolute;
  left: 50%;
  height: 4px;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  width: 16px;
  margin-left: -8px;
  opacity: 0.8;
  content: '';
}

.v-event-drag-bottom:hover::after {
  display: block;
}
.v-event-draggable {
  white-space: normal !important;
  padding: 3px 5px;
  font-size: 11px;
}

</style>
